SNI.Application.addModule('gallery-lead', (context) => {

  return {
    behaviors: ['truncate']
  };

});
